import { render, staticRenderFns } from "./CartInfoCard.vue?vue&type=template&id=28f7f942&scoped=true&"
import script from "./CartInfoCard.vue?vue&type=script&lang=js&"
export * from "./CartInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./CartInfoCard.vue?vue&type=style&index=0&id=28f7f942&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f7f942",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
